import type { ReactNode } from 'react';

export const symbol_search_check_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M584.5-376.76q75.5-75.77 75.5-184Q660-669 584.24-744.5q-75.77-75.5-184-75.5Q292-820 216.5-744.24q-75.5 75.77-75.5 184Q141-452 216.76-376.5q75.77 75.5 184 75.5Q509-301 584.5-376.76ZM356-515l-66-67q-9-9-21-9t-21.12 9.21q-9.12 9.22-9.5 21.5Q238-548 247-539l88 88q8.8 9 20.9 9 12.1 0 21.1-9l166-166q9-8.8 9-20.9 0-12.1-9.05-21.1-9.06-9-21.5-9-12.45 0-21.45 9L356-515Zm45 274q-133 0-226.5-93.5T81-561q0-133 93.5-226T401-880q133 0 226 93t93 226q0 58.53-19.5 110.26Q681-399 646-357l213 213q9 8.8 9 20.9 0 12.1-9.05 21.1-9.06 9-21.5 9Q825-93 816-102L604-314q-42.46 34.87-93.73 53.93Q459-241 401-241Zm0-320Z"
		/>
	</svg>
);
